// src/pages/LoginPage.js
import React, { useState } from "react"
import { Flex, Heading, Button, Input, useToast } from "@chakra-ui/react"
import { AuthService } from "../api" // Make sure this points to your AuthService
import { useNavigate } from "react-router-dom" // Import useNavigate
import axios from "axios"

export const LoginPage = () => {
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const toast = useToast()
  const navigate = useNavigate() // Initialize useNavigate

  const handleLogin = async () => {
    try {
      const token = await AuthService.login(username, password)
      // Store the token (you can use localStorage, context, or any state management solution)
      localStorage.setItem("token", token.access_token)
      // Add a request interceptor
      axios.interceptors.request.use(function (config) {
        config.headers.Authorization = "Bearer " + token.access_token

        return config
      })
      // Optionally, redirect to another page or show a success message
      toast({
        title: "Login successful.",
        description: "You have logged in successfully.",
        status: "success",
        duration: 3000,
        isClosable: true,
      })
      // Redirect or perform other actions here
      navigate("/swap") // Redirect to the /swap page
    } catch (error) {
      toast({
        title: "Login failed.",
        description: "An error occurred during login.",
        status: "error",
        duration: 3000,
        isClosable: true,
      })
    }
  }

  return (
    <Flex direction="column" align="center" justify="center" width="100vw" height="100vh" backgroundColor="gray.50" padding="4">
      <Heading mb="6">Login</Heading>
      <Input
        placeholder="Username"
        mb="4"
        value={username}
        onChange={e => setUsername(e.target.value)} // Update username state
      />
      <Input
        placeholder="Password"
        type="password"
        mb="4"
        value={password}
        onChange={e => setPassword(e.target.value)} // Update password state
      />
      <Button colorScheme="blue" onClick={handleLogin}>
        Log In
      </Button>
    </Flex>
  )
}
